/**
 * JeriCommerce Pass API · staging
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpContext 
        }       from '@angular/common/http';
import { Observable }                                        from 'rxjs';
import { OpenApiHttpParams, QueryParamStyle } from '../query.params';

// @ts-ignore
import { AutoTranslateDto } from '../model/auto-translate-dto';
// @ts-ignore
import { EntityTranslation } from '../model/entity-translation';
// @ts-ignore
import { ProgramLanguagesResponseDto } from '../model/program-languages-response-dto';
// @ts-ignore
import { SetProgramLanguagesDto } from '../model/set-program-languages-dto';
// @ts-ignore
import { UpsertTranslationDto } from '../model/upsert-translation-dto';
// @ts-ignore
import { UpsertTranslationsBulkDto } from '../model/upsert-translations-bulk-dto';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';
import {
    TranslationsServiceInterface,
    TranslationControllerAutoTranslateRequestParams,
    TranslationControllerGetJSONTranslationsRequestParams,
    TranslationControllerGetProgramLanguagesRequestParams,
    TranslationControllerGetTranslationsRequestParams,
    TranslationControllerSetProgramLanguagesRequestParams,
    TranslationControllerUpsertTranslationsRequestParams
} from './translations.serviceInterface';



@Injectable({
  providedIn: 'root'
})
export class TranslationsService extends BaseService implements TranslationsServiceInterface {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * Auto-translate missing fields using AI
     * Fills in translations for all enabled languages that are not yet in the database.  **How it works:** 1. You provide one or more source translations (the content in &#x60;sourceLocale&#x60;). 2. The service looks at the program\&#39;s **enabled languages** and determines which locales are missing for each &#x60;(entityType, entityId, field)&#x60; combination. 3. Missing translations are generated automatically using AI (Groq openai/gpt-oss-20b). 4. All translations — both provided and AI-generated — are persisted and returned. 5. When field contains dots \&quot;.\&quot;, then the get translations endpoint will parse them as nested objects  **How to use it:** - For customer app translations:   - Use &#x60;entityType&#x60; &#x3D; &#x60;customer_app&#x60;, &#x60;entityId&#x60; &#x3D; &#x60;null&#x60; and &#x60;field&#x60; &#x3D; translation key (e.g. &#x60;pass_label&#x60;, &#x60;points_label&#x60;, &#x60;coupon_description&#x60;). - For program content translations (e.g. tier names, reward descriptions):   - Use &#x60;entityType&#x60; &#x3D; a consistent slug representing the content type (e.g. &#x60;tier&#x60;, &#x60;reward&#x60;), &#x60;entityId&#x60; &#x3D; the UUID of the specific record and &#x60;field&#x60; &#x3D; a consistent key for the translatable field (e.g. &#x60;name&#x60;, &#x60;description&#x60;). - For tiers:   - Use &#x60;entityType&#x60; &#x3D; &#x60;tier&#x60;, &#x60;entityId&#x60; &#x3D; the tier UUID and &#x60;field&#x60; &#x3D; &#x60;name&#x60; | &#x60;content&#x60;. Resolved values are surfaced on &#x60;GET /:programId/tiers&#x60; (request locale wins, program default fills gaps); the tier\&#39;s own &#x60;name&#x60;/&#x60;content&#x60; columns hold the default-language text. - For sections:   - Use &#x60;entityType&#x60; &#x3D; &#x60;section&#x60;, &#x60;entityId&#x60; &#x3D; &#x60;sectionId&#x60; and  &#x60;field&#x60; &#x3D; &#x60;label&#x60;|&#x60;content&#x60; - For the front fields and the title of the loyalty card (&#x60;wallet.ios.fields&#x60; / &#x60;wallet.android.fields&#x60;, &#x60;wallet.ios.title&#x60; / &#x60;wallet.android.title&#x60;):   - Use &#x60;entityType&#x60; &#x3D; &#x60;wallet_field&#x60;, &#x60;entityId&#x60; &#x3D; &#x60;null&#x60; and &#x60;field&#x60; &#x3D; the part\&#39;s path: &#x60;ios.&lt;slot&gt;.label&#x60;|&#x60;ios.&lt;slot&gt;.value&#x60;, &#x60;android.&lt;slot&gt;.label&#x60;|&#x60;android.&lt;slot&gt;.value&#x60;, &#x60;ios.poster.footer.label&#x60;|&#x60;ios.poster.footer.value&#x60; for the iOS poster\&#39;s footer, or &#x60;tiers.&lt;tier&gt;.ios.&lt;slot&gt;.label&#x60; for a tier\&#39;s own text. Only configured parts are translated; on Google the values of &#x60;row1Start&#x60; and &#x60;row1End&#x60; take one string for every language.   - For the pass title: &#x60;ios.title&#x60; (Apple, store card and poster; &#x60;tiers.&lt;tier&gt;.ios.title&#x60; when the tier has its own title) and &#x60;android.title&#x60; (Google\&#39;s program name). The Google title is the class\&#39;s, one for the whole program: its translations are plain text (no variables) and a tier\&#39;s title has none. - For pass notification messages (balance / tier / reward):   - Use &#x60;entityType&#x60; &#x3D; &#x60;program&#x60;, &#x60;entityId&#x60; &#x3D; &#x60;null&#x60; and &#x60;field&#x60; &#x3D; one of &#x60;balanceNotificationsMessage&#x60;, &#x60;tierNotificationsMessage&#x60;, &#x60;rewardAvailableNotificationsMessage&#x60;. The resolved value is used when generating Apple and Google pass push notifications for customers whose &#x60;language&#x60; differs from the program default. - For coupons:   - Use &#x60;entityType&#x60; &#x3D; &#x60;coupon&#x60;, &#x60;entityId&#x60; &#x3D; coupon UUID and &#x60;field&#x60; &#x3D; &#x60;name&#x60; | &#x60;description&#x60;. Resolved values appear on the customer coupon-codes endpoint and on Apple and Google coupon code passes. - For the profile form of the COMPLETE_USER_PROFILE earning flow (&#x60;properties.form&#x60;):   - Use &#x60;entityId&#x60; &#x3D; the section, field or option UUID and &#x60;entityType&#x60; &#x3D; &#x60;profile_form_section&#x60; (&#x60;field&#x60; &#x3D; &#x60;title&#x60; | &#x60;description&#x60;), &#x60;profile_form_field&#x60; (&#x60;field&#x60; &#x3D; &#x60;label&#x60; | &#x60;help&#x60;) or &#x60;profile_form_option&#x60; (&#x60;field&#x60; &#x3D; &#x60;label&#x60;). The form itself holds the default-language text; resolved values are surfaced on &#x60;GET /v1/programs/:programId/customers/profile-form&#x60;. Translations of removed sections, fields and options are deleted when the flow is saved. - For campaigns (location and scheduled):   - Use &#x60;entityType&#x60; &#x3D; &#x60;campaign&#x60;, &#x60;entityId&#x60; &#x3D; campaign UUID and &#x60;field&#x60; &#x3D; one of &#x60;name&#x60;, &#x60;header&#x60;, &#x60;body&#x60;, &#x60;link&#x60;. The translated &#x60;header&#x60; / &#x60;body&#x60; / &#x60;link&#x60; are used when generating Apple and Google marketing push notifications and back-pass entries; for location campaigns the translated &#x60;body&#x60; is also used as the lock-screen &#x60;relevantText&#x60; on Apple passes.  **Important notes:** - The &#x60;locale&#x60; field in each translation item must match &#x60;sourceLocale&#x60;. - Locales that already have a stored translation are **skipped** (not overwritten). - Only languages enabled for the program (see &#x60;GET /:programId/languages&#x60;) are considered as targets. - Template variables like &#x60;{{firstName}}&#x60; are preserved as-is. 
     * @endpoint post /v1/{programId}/translations/auto-translate
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public translationControllerAutoTranslate(requestParameters: TranslationControllerAutoTranslateRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Array<UpsertTranslationDto>>;
    public translationControllerAutoTranslate(requestParameters: TranslationControllerAutoTranslateRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Array<UpsertTranslationDto>>>;
    public translationControllerAutoTranslate(requestParameters: TranslationControllerAutoTranslateRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Array<UpsertTranslationDto>>>;
    public translationControllerAutoTranslate(requestParameters: TranslationControllerAutoTranslateRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const autoTranslateDto = requestParameters?.autoTranslateDto;
        if (autoTranslateDto === null || autoTranslateDto === undefined) {
            throw new Error('Required parameter autoTranslateDto was null or undefined when calling translationControllerAutoTranslate.');
        }
        const programId = requestParameters?.programId;
        if (programId === null || programId === undefined) {
            throw new Error('Required parameter programId was null or undefined when calling translationControllerAutoTranslate.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/v1/${this.configuration.encodeParam({name: "programId", value: programId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/translations/auto-translate`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<Array<UpsertTranslationDto>>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: autoTranslateDto,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get all translations for a given entity type
     * Returns a nested JSON object ready to be consumed by the client. Field keys using dot notation (e.g. &#x60;points_page.point_label&#x60;) are expanded into nested objects.
     * @endpoint get /v1/{programId}/translations/{entityType}/json
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public translationControllerGetJSONTranslations(requestParameters: TranslationControllerGetJSONTranslationsRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<{ [key: string]: any; }>;
    public translationControllerGetJSONTranslations(requestParameters: TranslationControllerGetJSONTranslationsRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<{ [key: string]: any; }>>;
    public translationControllerGetJSONTranslations(requestParameters: TranslationControllerGetJSONTranslationsRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<{ [key: string]: any; }>>;
    public translationControllerGetJSONTranslations(requestParameters: TranslationControllerGetJSONTranslationsRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const locale = requestParameters?.locale;
        if (locale === null || locale === undefined) {
            throw new Error('Required parameter locale was null or undefined when calling translationControllerGetJSONTranslations.');
        }
        const entityType = requestParameters?.entityType;
        if (entityType === null || entityType === undefined) {
            throw new Error('Required parameter entityType was null or undefined when calling translationControllerGetJSONTranslations.');
        }
        const programId = requestParameters?.programId;
        if (programId === null || programId === undefined) {
            throw new Error('Required parameter programId was null or undefined when calling translationControllerGetJSONTranslations.');
        }

        let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'locale',
            <any>locale,
            QueryParamStyle.Form,
            true,
        );


        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/v1/${this.configuration.encodeParam({name: "programId", value: programId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/translations/${this.configuration.encodeParam({name: "entityType", value: entityType, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/json`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<{ [key: string]: any; }>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters.toHttpParams(),
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get active languages for a program
     * @endpoint get /v1/{programId}/languages
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public translationControllerGetProgramLanguages(requestParameters: TranslationControllerGetProgramLanguagesRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<ProgramLanguagesResponseDto>;
    public translationControllerGetProgramLanguages(requestParameters: TranslationControllerGetProgramLanguagesRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<ProgramLanguagesResponseDto>>;
    public translationControllerGetProgramLanguages(requestParameters: TranslationControllerGetProgramLanguagesRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<ProgramLanguagesResponseDto>>;
    public translationControllerGetProgramLanguages(requestParameters: TranslationControllerGetProgramLanguagesRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const programId = requestParameters?.programId;
        if (programId === null || programId === undefined) {
            throw new Error('Required parameter programId was null or undefined when calling translationControllerGetProgramLanguages.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/v1/${this.configuration.encodeParam({name: "programId", value: programId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/languages`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<ProgramLanguagesResponseDto>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get all entity translations for a given entity type
     * @endpoint get /v1/{programId}/translations/{entityType}
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public translationControllerGetTranslations(requestParameters: TranslationControllerGetTranslationsRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Array<EntityTranslation>>;
    public translationControllerGetTranslations(requestParameters: TranslationControllerGetTranslationsRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Array<EntityTranslation>>>;
    public translationControllerGetTranslations(requestParameters: TranslationControllerGetTranslationsRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Array<EntityTranslation>>>;
    public translationControllerGetTranslations(requestParameters: TranslationControllerGetTranslationsRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const locale = requestParameters?.locale;
        if (locale === null || locale === undefined) {
            throw new Error('Required parameter locale was null or undefined when calling translationControllerGetTranslations.');
        }
        const entityType = requestParameters?.entityType;
        if (entityType === null || entityType === undefined) {
            throw new Error('Required parameter entityType was null or undefined when calling translationControllerGetTranslations.');
        }
        const programId = requestParameters?.programId;
        if (programId === null || programId === undefined) {
            throw new Error('Required parameter programId was null or undefined when calling translationControllerGetTranslations.');
        }

        let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'locale',
            <any>locale,
            QueryParamStyle.Form,
            true,
        );


        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/v1/${this.configuration.encodeParam({name: "programId", value: programId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/translations/${this.configuration.encodeParam({name: "entityType", value: entityType, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<Array<EntityTranslation>>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters.toHttpParams(),
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Update active languages and default for a program
     * @endpoint put /v1/{programId}/languages
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public translationControllerSetProgramLanguages(requestParameters: TranslationControllerSetProgramLanguagesRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<ProgramLanguagesResponseDto>;
    public translationControllerSetProgramLanguages(requestParameters: TranslationControllerSetProgramLanguagesRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<ProgramLanguagesResponseDto>>;
    public translationControllerSetProgramLanguages(requestParameters: TranslationControllerSetProgramLanguagesRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<ProgramLanguagesResponseDto>>;
    public translationControllerSetProgramLanguages(requestParameters: TranslationControllerSetProgramLanguagesRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const setProgramLanguagesDto = requestParameters?.setProgramLanguagesDto;
        if (setProgramLanguagesDto === null || setProgramLanguagesDto === undefined) {
            throw new Error('Required parameter setProgramLanguagesDto was null or undefined when calling translationControllerSetProgramLanguages.');
        }
        const programId = requestParameters?.programId;
        if (programId === null || programId === undefined) {
            throw new Error('Required parameter programId was null or undefined when calling translationControllerSetProgramLanguages.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/v1/${this.configuration.encodeParam({name: "programId", value: programId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/languages`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<ProgramLanguagesResponseDto>('put', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: setProgramLanguagesDto,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Upsert translations in bulk
     * @endpoint put /v1/{programId}/translations
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public translationControllerUpsertTranslations(requestParameters: TranslationControllerUpsertTranslationsRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Array<EntityTranslation>>;
    public translationControllerUpsertTranslations(requestParameters: TranslationControllerUpsertTranslationsRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Array<EntityTranslation>>>;
    public translationControllerUpsertTranslations(requestParameters: TranslationControllerUpsertTranslationsRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Array<EntityTranslation>>>;
    public translationControllerUpsertTranslations(requestParameters: TranslationControllerUpsertTranslationsRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const upsertTranslationsBulkDto = requestParameters?.upsertTranslationsBulkDto;
        if (upsertTranslationsBulkDto === null || upsertTranslationsBulkDto === undefined) {
            throw new Error('Required parameter upsertTranslationsBulkDto was null or undefined when calling translationControllerUpsertTranslations.');
        }
        const programId = requestParameters?.programId;
        if (programId === null || programId === undefined) {
            throw new Error('Required parameter programId was null or undefined when calling translationControllerUpsertTranslations.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/v1/${this.configuration.encodeParam({name: "programId", value: programId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/translations`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<Array<EntityTranslation>>('put', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: upsertTranslationsBulkDto,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

}
